export default __webpack_public_path__ + "static/media/datePickerIcon2.d4cc5867.svg";